<app-entity-mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle title="Schedules"></app-entity-mat-dialog-title>

<div [ngClass]="{
        'loading-shade': showProgressSpinner
     }">

    <div mat-dialog-content>

        <mat-progress-spinner class="matProgressSpinnerCentered" *ngIf="showProgressSpinner" mode="indeterminate">
        </mat-progress-spinner>

        <mat-tab-group class="eventTabGroup" [(selectedIndex)]="this.selectedIndex" (selectedTabChange)="setFormMode($event.index)" animationDuration="0ms" #tabs>

            <mat-tab label="View" [disabled]="this.initActionType == 'create'">
                <app-entity-mat-tab-view [entityData]="entityData"></app-entity-mat-tab-view>
            </mat-tab>

            <mat-tab label="{{(this.initActionType == 'create' ? 'Create' : 'Edit')}}">
                <app-error-message [message]=this.errorMessage></app-error-message>

                <!-- Form -->
                <form (ngSubmit)="onSubmit(f)" #f="ngForm" class="form">
                    <div class="container">
                        <div class="row">

                            <div class="col-6">
                                <mat-form-field class="full-width-field">
                                    <mat-label>Schedule Type</mat-label>
                                    <mat-select matInput ngModel name="field_type" required (selectionChange)="updateLessonDefaultTimes($event.value)">
                                        <mat-option *ngFor="let element of sortedScheduleTypes"
                                            [value]="element.id">
                                            {{ element.name }}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>

                            <div class="col-6" *ngIf="this.actionType != 'create'">
                                <mat-form-field class="full-width-field">
                                    <mat-label>Instructor</mat-label>
                                    <mat-select matInput ngModel name="field_schedule_instructor">
                                        <mat-option>None</mat-option>
                                        <ng-container *ngFor="let element of _fieldsService.instructorData(); let i = index">
                                            <mat-option *ngIf="element.status !== '0' || (element.status === '0' && element.uid === field_schedule_instructor)"
                                                        [value]="element.uid">
                                                {{ element.value }}
                                                <ng-container *ngIf="element.status === '0' && element.uid === field_schedule_instructor"></ng-container>
                                            </mat-option>
                                        </ng-container>
                                    </mat-select>
                                </mat-form-field>
                            </div>

                            <div class="col-6" *ngIf="this.actionType == 'create'">
                                <mat-form-field class="full-width-field">
                                    <mat-label>Instructor</mat-label>
                                    <mat-select matInput multiple ngModel name="field_schedule_instructor">
                                        <mat-option>None</mat-option>
                                        <ng-container *ngFor="let element of this._fieldsService.instructorData()">
                                            <mat-option *ngIf="element.status !== '0' || (element.status === '0' && element.uid === field_instructor)"
                                                        [value]="element.uid">
                                                {{ element.value }}
                                                <ng-container *ngIf="element.status === '0' && element.uid === field_instructor"></ng-container>
                                            </mat-option>
                                        </ng-container>
                                    </mat-select>
                                </mat-form-field>
                            </div>

                            <div class="col-6">
                                <mat-form-field class="full-width-field">
                                    <mat-label>Choose a date</mat-label>
                                    <input [(ngModel)]="field_date_and_time"
                                           name="field_date_and_time"
                                           matInput
                                           type="text"
                                           appFlatpickrDatetime
                                           [enableTime]="true"
                                           [minuteIncrement]="15"
                                           [setCurrentTimeOnOpen]="true"
                                           (ngModelChange)="handleDateTimeChange($event)"
                                           placeholder="Choose a date"
                                           required
                                           readonly>
                                    <mat-icon matSuffix>calendar_today</mat-icon>
                                </mat-form-field>
                            </div>


                            <div class="col-6">
                                <mat-form-field class="full-width-field">
                                    <mat-label>Duration</mat-label>
                                    <mat-select matInput ngModel name="field_duration">
                                        <mat-option>None</mat-option>
                                        <mat-option *ngFor="let element of this._fieldsService.durations"
                                            [value]="element.value">
                                            {{ element.value }}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>

                            <div class="col-12" *ngIf="this.actionType === 'create'">
                                <app-standing-series
                                  [studentAccountId]="''"
                                  [instructorId]="f?.value?.field_schedule_instructor?.[0] || ''"
                                  [duration]="f?.value?.field_duration || '00:45'"
                                  [time]="field_date_and_time ? (field_date_and_time | date:'HH:mm') : ''"
                                  [startDate]="field_date_and_time ? (field_date_and_time | date:'yyyy-MM-dd') : ''"
                                  [lessonType]="f?.value?.field_type || ''"
                                  [bundle]="'schedules'"
                                  [selectedEnrollment]="null"
                                  [supportsEnrollment]="false"
                                  [requiresStudent]="false"
                                  [requiresInstructor]="true"
                                  (recurrenceChanged)="onRecurrenceChanged($event)">
                                </app-standing-series>
                                <div class="text-muted small mt-1" *ngIf="isRecurring">
                                    A separate recurring schedule is created for each selected instructor.
                                </div>
                            </div>

                            <div class="col-12">
                                <mat-form-field class="full-width-field">
                                    <mat-label>Notes</mat-label>
                                    <textarea ngModel name="field_notes" matInput placeholder=""></textarea>
                                </mat-form-field>
                            </div>


                        </div>
                    </div>
                </form>
            </mat-tab>

            <mat-tab label="Delete" [disabled]="this.initActionType == 'create'">
                <app-entity-confirm-delete></app-entity-confirm-delete>
            </mat-tab>

        </mat-tab-group>

    </div>

</div>

<mat-dialog-actions align="end">
    <ng-container *ngIf="this.actionType === 'create'">
        <button type="button"
                [disabled]="isSaving || !isStandingAppointmentValid() || (isRecurring && (!recurrenceConfig || recurrenceConfig.days.length === 0))"
                (click)="onSubmit(f);" mat-raised-button color="primary">{{ isRecurring
                                     ? (isSaving ? 'Generating...' : 'Save & Generate Series')
                                     : (isSaving ? 'Saving...' : 'Save') }}</button>
    </ng-container>

    <!-- Conflict display for recurring save (grouped by instructor) -->
    <div *ngIf="seriesConflicts?.length > 0" class="series-conflict-section" style="width: 100%; padding: 12px 0;">
        <div style="display: flex; align-items: center; gap: 8px; color: #c62828; margin-bottom: 8px;">
            <mat-icon>warning</mat-icon>
            <strong>{{ seriesConflicts.length }} conflict(s) found</strong>
        </div>
        <div style="max-height: 120px; overflow-y: auto; margin-bottom: 8px;">
            <div *ngFor="let c of seriesConflicts" style="font-size: 0.9em; padding: 2px 0; color: #555;">
                <strong *ngIf="c.instructor">{{ c.instructor }}</strong><span *ngIf="c.instructor"> &mdash; </span>{{ c.date | date:'EEE, MMM d' }} &mdash; {{ c.message }}
            </div>
        </div>
        <div style="display: flex; gap: 8px;">
            <button mat-raised-button color="warn" [disabled]="isSaving" (click)="generateIgnoringConflicts()">
                Generate Anyway
            </button>
            <button mat-raised-button [disabled]="isSaving" (click)="cancelRecurringSave()">
                Cancel
            </button>
        </div>
    </div>
    <ng-container *ngIf="this.actionType === 'edit'">
        <ng-container *ngIf="this.initActionType == 'edit'">
            <button type="button" [disabled]="isSaving" (click)="setFormMode('delete')" mat-raised-button color="accent">Delete</button>
            <button type="button" [disabled]="isSaving" (click)="onSubmit(f);" mat-raised-button color="primary">{{ isSaving ? 'Saving...' : 'Save' }}</button>
        </ng-container>
        <ng-container *ngIf="this.initActionType == 'create'">
            <button type="button" (click)="closeDialog()" mat-raised-button color="accent">Cancel</button>
            <button type="button" [disabled]="isSaving" (click)="onSubmit(f);" mat-raised-button color="primary">{{ isSaving ? 'Saving...' : 'Save' }}</button>
        </ng-container>
    </ng-container>
    <ng-container *ngIf="this.actionType === 'delete'">
        <button (click)="setFormMode('edit')" type="submit" mat-raised-button color="accent">Cancel</button>
        <button (click)="onDeleteSubmit(this._injectedDialogData['data']['EntityID'])" type="submit" mat-raised-button
            color="accent">Delete</button>
    </ng-container>
</mat-dialog-actions>
